module.exports = __webpack_public_path__ + "img/20171229_172030.dc581d80.jpg";